<template>
    <v-autocomplete
        v-model="experiment"
        @update:model-value="onChange"
        :items="items"
        :loading="isLoading"
        v-model:search="search"
        append-icon=""
        :autofocus="autofocus"
        clearable
        hide-selected
        item-title="exp"
        item-value="exp"
        label="Experiment Id"
        placeholder="Start typing to Search"
        prepend-icon="$database-search"
        return-object
    >
        <template v-slot:no-data="">
            <div>
                <div
                    v-if="search && search.length > 3"
                    class="pr-4 pl-4 pt-3 b-3 bg-amber-lighten-2"
                    style="width: 335px"
                >
                    <p>
                        Make sure that your Benchling entry metadata tab has 1) the “Invaio Notebook
                        Entry” schema assigned and 2) a protocol associated with it.
                    </p>
                </div>
                <div v-else class="mr-4 ml-4 mt-3 mb-3">Keep typing...</div>
            </div>
        </template>
    </v-autocomplete>
</template>

<script>
import { defineComponent } from "vue";

import _ from "lodash";
import { mapActions } from "vuex";
import { search as apiSearch } from "@/services/api.services";
import { EventBus } from "@/lib/event-bus";

export default defineComponent({
    name: "ExperimentsSearch",
    props: ["autofocus", "value"],

    data: () => ({
        entries: [],
        experiment: undefined,
        isLoading: false,
        search: "",
        textLimit: 60,
    }),

    computed: {
        fields() {
            if (!this.modelValue) return [];

            return Object.keys(this.modelValue).map((key) => {
                return {
                    key,
                    value: this.modelValue[key] || "n/a",
                };
            });
        },
        items() {
            return this.entries.map((entry) => {
                const name =
                    entry.name.length > this.textLimit
                        ? entry.name.slice(0, this.textLimit) + "..."
                        : entry.name;

                return Object.assign({}, entry, { name });
            });
        },
    },

    created() {
        // Enable debounce on method
        this.doSearch = _.debounce(this.doSearch, 200);
    },

    methods: {
        ...mapActions("plateCreate", ["setExperiment"]),
        doSearch: async (criteria, self) => {
            self.isLoading = true;
            try {
                const results = await apiSearch(criteria);
                self.entries = results;
            } catch (err) {
                console.error(err);
            } finally {
                self.isLoading = false;
            }
        },
        onChange($event) {
            this.setExperiment(this.experiment);
            this.$emit("update:modelValue", $event, this.experiment);
        },
    },

    watch: {
        search(val) {
            this.doSearch(val, this);
        },
    },
});
</script>
<style scoped></style>
